import { separatorCss } from "./SectionSeparator.style";

const SectionSeparator = () => {
  return <hr css={separatorCss} />;
};

export default SectionSeparator;
